import clsx from 'clsx';
import {NavLink} from 'react-router-dom';
import {LocaleSwitcher} from '../../i18n/locale-switcher';
import {Trans} from '../../i18n/trans';
import {useSettings} from '../../core/settings/use-settings';
import {getLegalPages} from '../../custom-page/get-legal-pages';

interface Props {
  className?: string;
  padding?: string;
}

interface FooterLink {
  to: string;
  label: string;
}

/**
 * Site footer links are hard-coded (not Appearance/DB menus).
 * Added: 2026-10-08.
 */
function footerLinks(): FooterLink[] {
  const legal = getLegalPages();
  return [
    {to: '/docs', label: 'Documentation'},
    {to: '/contact', label: 'Contact Us'},
    {to: legal.privacy_policy, label: 'Privacy Policy'},
    {to: legal.terms_of_service, label: 'Terms of Service'},
  ];
}

export function Footer({className, padding}: Props) {
  const year = new Date().getFullYear();
  const {branding} = useSettings();
  return (
    <footer
      className={clsx(
        'text-sm',
        padding ? padding : 'pb-28 pt-54 md:pb-54',
        className,
      )}
    >
      <Menus />
      <div className="items-center justify-between gap-30 text-center text-muted md:flex md:text-left">
        <Trans
          message="Copyright © :year :name, All Rights Reserved"
          values={{year, name: branding.site_name}}
        />
        <div>
          <LocaleSwitcher />
        </div>
      </div>
    </footer>
  );
}

function Menus() {
  return (
    <div className="mb-14 items-center justify-between gap-30 overflow-x-auto border-b pb-14 md:flex">
      <div className="flex items-center gap-30 text-primary">
        {footerLinks().map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className="whitespace-nowrap outline-none focus-visible:ring-2"
          >
            <Trans message={item.label} />
          </NavLink>
        ))}
      </div>
    </div>
  );
}
